export default {
      id: "ic-plan-micropelle-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-micropelle-usage",
      toString: function () {
        return this.url;
      }
    }